import { action } from 'typesafe-actions';
import {
  TIPSTER_PREFERENCES_FAILURE,
  TIPSTER_PREFERENCES_REQUEST,
  TIPSTER_PREFERENCES_SUCCESS,
} from '../../constants/tipsterPreferences';

export const tipsterPreferencesRequestAction = (tipsterID: string) =>
  action(TIPSTER_PREFERENCES_REQUEST, tipsterID);
export const tipsterPreferencesSuccessAction = (data: any) =>
  action(TIPSTER_PREFERENCES_SUCCESS, data);
export const tipsterPreferencesFailureAction = (e: any) =>
  action(TIPSTER_PREFERENCES_FAILURE, e);

export const tipsterPreferencesActions = {
  tipsterPreferencesRequestAction,
  tipsterPreferencesSuccessAction,
  tipsterPreferencesFailureAction,
};
